import { gql } from '@apollo/client';

export const QUERY_PEDAGOGIES = gql`
  query AllPedagogiesAndTypes {
    pedagogies(sort: "order:asc") {
      data {
        id
        attributes {
          name
          subtitle
          info
          desc
          order
          revervedToProf
          pedagogie_type {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
    findPedagogieTypeWithRelatedPedagogies {
      id
      name
      pedagogies {
        name
      }
    }
  }
`;
